/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the OrderExternalCollaboratorInputDto interface.
 */
export function instanceOfOrderExternalCollaboratorInputDto(value) {
    return true;
}
export function OrderExternalCollaboratorInputDtoFromJSON(json) {
    return OrderExternalCollaboratorInputDtoFromJSONTyped(json, false);
}
export function OrderExternalCollaboratorInputDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'idUtenteIntranet': json['idUtenteIntranet'] == null ? undefined : json['idUtenteIntranet'],
        'tariffa': json['tariffa'] == null ? undefined : json['tariffa'],
        'numGiornate': json['numGiornate'] == null ? undefined : json['numGiornate'],
        'fkOrdine': json['fkOrdine'] == null ? undefined : json['fkOrdine'],
    };
}
export function OrderExternalCollaboratorInputDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'idUtenteIntranet': value['idUtenteIntranet'],
        'tariffa': value['tariffa'],
        'numGiornate': value['numGiornate'],
        'fkOrdine': value['fkOrdine'],
    };
}
